import { useState } from "react";
import { Button, Loader } from "@mantine/core";
import "./PaymentButtons.scss";
import { IconArrowUpRight, IconPlus } from "@tabler/icons-react";
import PaymentRequestModal from "./PaymentRequestModal/PaymentRequestModal";
import { getStripeDashboardUrl } from "@/utils/api/payments";
import { openNewTab } from "@/utils/browserUtils";

interface PaymentButtonsProps {
  showDashboardButton?: boolean;
  showRequestPaymentButton?: boolean;
}

const PaymentButtons = ({
  showDashboardButton = true,
  showRequestPaymentButton = true,
}: PaymentButtonsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleViewDashboard = async () => {
    setIsLoading(true);
    try {
      const response = await getStripeDashboardUrl();
      if (response?.content?.url) {
        openNewTab(response.content.url);
      }
    } catch (error) {
      console.error("Failed to fetch Stripe dashboard URL:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="payment-buttons">
      {showDashboardButton && (
        <Button
          variant="outline"
          bg={"white"}
          size="md"
          radius={"md"}
          leftSection={isLoading ? <Loader size="xs" /> : <IconArrowUpRight />}
          onClick={handleViewDashboard}
          disabled={isLoading}
        >
          {"View Dashboard"}
        </Button>
      )}
      {showRequestPaymentButton && (
        <Button
          color="#0077CC"
          leftSection={<IconPlus />}
          size="md"
          radius={"md"}
          onClick={() => setIsModalOpen(true)}
        >
          Request Payment
        </Button>
      )}

      {/* Payment Request Modal */}
      <PaymentRequestModal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default PaymentButtons;
